import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["category", "tags", "preparedPageBuilderComponents"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { buildPBComponents, getLightboxImages } from '@blaze-cms/plugin-page-builder-fe';
import { Header, MainContextProvider } from '@blaze-cms/nextjs-components';
import { getSearchFilter, checkForGtm } from '../helpers';
import { PREVIEW_MODE } from '../constants';
import { DebugSidebar } from '../components';
const ContentContainer = ({
  fullUrl,
  pageData,
  isPreview,
  itemId,
  itemEntity
}) => {
  const [open, setOpen] = useState(false);
  const [debugOptions, setDebugOptions] = useState({
    editorModeEnabled: false
  });
  const [selectedImage, setSelectedImage] = useState(0);
  const toggleModal = () => setOpen(!open);
  useEffect(() => {
    if (open) setOpen(false);
  },
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [fullUrl]);
  const {
      category,
      tags,
      preparedPageBuilderComponents
    } = pageData,
    metaProps = _objectWithoutProperties(pageData, _excluded);
  const pageBuilder = preparedPageBuilderComponents || [];
  const options = {
    parent: {
      itemId,
      itemEntity,
      category,
      tags
    }
  };
  const searchFilterItems = getSearchFilter(pageBuilder);
  const defaultSearchFilter = searchFilterItems[0];
  // TODO check if this can be removed
  if (defaultSearchFilter && !defaultSearchFilter.settings.url) {
    options.searchFilter = defaultSearchFilter;
  }
  options.allSearchFilters = searchFilterItems;
  const lightboxImages = getLightboxImages(pageBuilder);
  const hasGTM = checkForGtm(pageBuilder);
  const GlobalLigthBoxProps = {
    open,
    setOpen,
    toggleModal,
    selectedImage,
    lightboxImages,
    setSelectedImage
  };
  const buildPBComponentsOptions = _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, options), metaProps), GlobalLigthBoxProps), {}, {
    hasGTM
  });
  const updatedDebugOptions = (newOptions = {}) => {
    setDebugOptions(_objectSpread(_objectSpread({}, debugOptions), newOptions));
  };
  return /*#__PURE__*/React.createElement(MainContextProvider, {
    value: {
      fullUrl,
      isPreview,
      itemId,
      itemEntity,
      hasGTM,
      debugOptions
    }
  }, /*#__PURE__*/React.createElement(Header, metaProps), /*#__PURE__*/React.createElement(DebugSidebar, {
    itemId: itemId,
    itemEntity: itemEntity,
    updatedDebugOptions: updatedDebugOptions
  }), isPreview && /*#__PURE__*/React.createElement("div", {
    className: "preview-header"
  }, PREVIEW_MODE), !!pageBuilder.length && buildPBComponents(pageBuilder, buildPBComponentsOptions, true));
};
ContentContainer.propTypes = {
  fullUrl: PropTypes.string.isRequired,
  pageData: PropTypes.object.isRequired,
  isPreview: PropTypes.bool.isRequired,
  itemId: PropTypes.string.isRequired,
  itemEntity: PropTypes.string.isRequired
};
export default ContentContainer;
//# sourceMappingURL=ContentContainer.js.map